import { isToday, isTomorrow } from 'date-fns';

const DAY_ABBREVIATIONS = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
};

const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
const WEEKENDS = ['saturday', 'sunday'];

const abbreviateDay = (day) => {
  return DAY_ABBREVIATIONS[day.toLowerCase()] || day;
};

export const useDateBadge = (schedule) => {
  if (!schedule || !schedule[0]) return { badgeText: null, variant: null };

  const { startDate, endDate, weekdays } = schedule[0];
  const start = new Date(startDate);
  const end = new Date(endDate);
  const oneDayEvent = start.toDateString() === end.toDateString();

  const MS_IN_DAY = 1000 * 60 * 60 * 24; // 1 day in milliseconds
  const rangeInDays = Math.ceil((end - start) / MS_IN_DAY) + 1; // days between start and end inclusive
  const isShortRange = !oneDayEvent && rangeInDays <= 7;

  const isStartToday = isToday(start);
  const isStartTomorrow = isTomorrow(start);

  const getWeekdaySchedule = () => {
    if (!weekdays || weekdays.length === 0) return null;
    if (oneDayEvent) return null;

    const activeDays = weekdays.filter((day) => !day.isClosed);
    if (activeDays.length === 7) return null;

    const isWeekdaysOnly =
      activeDays.length === 5 &&
      activeDays.every((day) => WEEKDAYS.includes(day.weekday.toLowerCase()));
    if (isWeekdaysOnly) return null;

    const isWeekendsOnly =
      activeDays.length === 2 &&
      activeDays.every((day) => WEEKENDS.includes(day.weekday.toLowerCase()));
    if (isWeekendsOnly) return 'Weekends';

    if (activeDays.length > 0) {
      const days = activeDays.map((day) => abbreviateDay(day.weekday));

      if (activeDays.length === 1) {
        return `Every ${days[0]}`;
      }
      if (activeDays.length === 2) {
        return days.join(' & ');
      }
      if (activeDays.length > 3) {
        return null;
      }
      const allButLast = days.slice(0, -1);
      const last = days[days.length - 1];
      return `${allButLast.join(', ')} & ${last}`;
    }
    return null;
  };

  const badgeText = isStartToday
    ? 'Today'
    : isStartTomorrow
    ? 'Tomorrow'
    : isShortRange
    ? null
    : getWeekdaySchedule();

  const variant = isStartToday
    ? 'today'
    : isStartTomorrow
    ? 'tomorrow'
    : badgeText
    ? 'recurring'
    : null;

  return { badgeText, variant };
};
